var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-flex-grow-1 c-flex-equal c-d-flex c-flex-column c-bord-r c-day",staticStyle:{"min-width":"300px"}},[_vm._t("header"),_c('div',{staticClass:"of-y c-flex-grow-1"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }